export const displayPhoneNumberFormattoPlain = (phoneNumber: string) => {
  const digitsOnly = phoneNumber.replace(/\D/g, "");
  const phoneNum = digitsOnly.length > 10 ? digitsOnly?.substring(1): digitsOnly
  return phoneNum;
};
